import { Avatar, Stack, Typography } from '@mui/material';

type DisplayContentInfoProps = {
  title: string;
  value: string | string[];
  'data-testid': string;
  smallImage?: boolean;
};

const DisplayContentInfo = ({
  title,
  value,
  'data-testid': dataTestId,
  smallImage = false,
}: DisplayContentInfoProps) => {
  return (
    <Stack mb={2}>
      <Typography
        mb={0.5}
        variant="h5"
        data-testid={`DisplayContentInfo.${dataTestId}.Title`}
      >
        {title}
      </Typography>
      {typeof value === 'string' && (
        <Typography
          variant="body2"
          data-testid={`DisplayContentInfo.${dataTestId}.Value`}
        >
          {value}
        </Typography>
      )}
      {typeof value === 'object' && (
        <Avatar
          src={value[0]}
          variant="square"
          sx={{ width: smallImage ? 100 : 200, height: 100 }}
          data-testid={`DisplayContentInfo.${dataTestId}`}
        />
      )}
    </Stack>
  );
};

export default DisplayContentInfo;
